import { defineVuePlugin } from '#/vue-plugins'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'

import { getAppConfig } from '@/shared/lib/tenant'

import { authGuard, createModuleGuard } from './guards'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default defineVuePlugin((app) => {
  const checkModuleAccess = createModuleGuard(app)
  const config = getAppConfig(app)

  router.beforeEach(async (to, from, next) => {
    // Специальная обработка для страницы ошибки 500
    if (to.path === '/500') {
      return next()
    }

    // Сначала проверяем доступность модуля для тенанта
    const moduleRedirect = checkModuleAccess(to.path)
    if (moduleRedirect) {
      return next(moduleRedirect)
    }

    // Затем проверяем авторизацию и права доступа
    await authGuard(to, from, next, config)
  })

  app.use(router)
})
